import React, { useEffect, useRef } from 'react';
import { deviceType } from '../../../Utilities';
// import "@google/model-viewer";
const isTouchDevice = require('is-touch-device');


function ModelViewer(props) {
  const modelRef = useRef(null);

  let policy = 'always-allow'
  if (isTouchDevice()) {
    policy = 'allow-when-focused'
  }
  let loaderProps = {}
  let arProps = {};
  if (!props.src) {
    loaderProps = {
      loading: "eager",
      poster: "10826_HeadOn-min.jpg"
    }
  }
  if (props.ar == false) {

  } else {
    arProps = {
      ar: true
    }
  }

  useEffect(() => {
    if (deviceType() == 'desktop') {
      const el = modelRef.current;
      if (el) {
        const stop = (e) => e.stopPropagation();

        el.addEventListener('touchstart', stop, { passive: true });
        el.addEventListener('touchmove', stop, { passive: true });
        el.addEventListener('mousedown', stop);
        el.addEventListener('pointerdown', stop);

        return () => {
          el.removeEventListener('touchstart', stop);
          el.removeEventListener('touchmove', stop);

          el.removeEventListener('mousedown', stop);
          el.removeEventListener('pointerdown', stop);
        };
      }
    }
  }, []);

  return (

    <React.Fragment>
      <model-viewer environment-image="neutral"
        ref={modelRef}
        class={"disablehover model-viewer-class " + props.class}
        {...loaderProps}
        {...arProps}
        // ar={props.ar == false ? false : true}
        data-js-focus-visible
        poster={props.poster ? props.poster : ""}
        shadow-intensity={1}
        interaction-policy={policy}
        src={props.src ? props.src : "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/10826.glb"}
        alt="Velvet Hagen Dining Chair"
        auto-rotate
        camera-controls
        interaction-prompt-threshold={0}
        ar-modes="webxr scene-viewer quick-look"
        background-color="#FFFFFF"
      >
      </model-viewer>

    </React.Fragment>

  );
}


export default ModelViewer;
